import { render, staticRenderFns } from "./UsuariosInactivos.vue?vue&type=template&id=5cdc5fc4&"
import script from "./UsuariosInactivos.vue?vue&type=script&lang=js&"
export * from "./UsuariosInactivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports